import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-search-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg font-bold">磁力搜索指南</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              磁力搜索是最专业的磁力搜索知识平台，提供磁力搜索技巧、工具推荐和安全指南，帮助用户高效安全地使用磁力搜索服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#faq"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200"
                >
                  常见问题
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">
              资源分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">
              热门文章
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/article/cili-sousuo-rumen"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200"
                >
                  磁力搜索入门指南
                </Link>
              </li>
              <li>
                <Link
                  to="/article/zuijia-cili-sousuo-yinqing"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200"
                >
                  最佳磁力搜索引擎推荐
                </Link>
              </li>
              <li>
                <Link
                  to="/article/cili-sousuo-anquan-jiqiao"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200"
                >
                  磁力搜索安全技巧
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 磁力搜索指南 - 版权所有。本站为知识分享平台，不提供任何资源的直接下载。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-background-400 hover:text-primary-400 transition-colors duration-200"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-background-400 hover:text-primary-400 transition-colors duration-200"
              rel="nofollow"
            >
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}